import { Routes, Route } from 'react-router-dom';
import { Toaster } from '@/components/ui/toaster';
import { Landing } from '@/pages/landing';
import { ComoFunciona } from '@/pages/como-funciona';
import { Precos } from '@/pages/precos';
import { Advogados } from '@/pages/advogados';
import { AdvogadoPerfil } from '@/pages/advogado-perfil';
import { TermosMediacao } from '@/pages/termos-mediacao';
import { Faq } from '@/pages/faq';
import { Templates } from '@/pages/templates';
import { Login } from '@/pages/auth/login';
import { Cadastro } from '@/pages/auth/cadastro';
import { CadastroAdvogado } from '@/pages/auth/cadastro-advogado';
import { ConfirmarEmail } from '@/pages/auth/confirmar';
import { EsqueciSenha } from '@/pages/auth/esqueci-senha';
import { ResetarSenha } from '@/pages/auth/resetar-senha';
import { ProtectedRoute } from '@/components/auth/protected-route';
import { DashboardUser } from '@/pages/app/dashboard';
import { ContratosLista } from '@/pages/app/contratos';
import { ContratoNovo } from '@/pages/app/contratos-novo';
import { ContratoDetalhe } from '@/pages/app/contrato-detalhe';
import { UserTarefas } from '@/pages/app/tarefas-lista';
import { TarefaDetalhe } from '@/pages/app/tarefa-detalhe';
import { DemandaNova } from '@/pages/app/demanda-nova';
import { LawyerDashboard } from '@/pages/lawyer/dashboard';
import { LawyerPerfil } from '@/pages/lawyer/perfil';
import { LawyerPrecos } from '@/pages/lawyer/precos';
import { LawyerTarefas } from '@/pages/lawyer/tarefas';
import { LawyerFinanceiro } from '@/pages/lawyer/financeiro';
import { AdminDashboard } from '@/pages/admin/dashboard';
import { AdminUsuarios } from '@/pages/admin/usuarios';
import { AdminAdvogados } from '@/pages/admin/advogados';
import { AdminTarefas } from '@/pages/admin/tarefas';
import { AdminTarefaDetalhe } from '@/pages/admin/tarefa-detalhe';
import { AdminContratos } from '@/pages/admin/contratos';
import { AdminPagamentos } from '@/pages/admin/pagamentos';
import { AdminAvaliacoes } from '@/pages/admin/avaliacoes';
import { AdminAuditLog } from '@/pages/admin/audit-log';
import { AdminConfiguracoes } from '@/pages/admin/configuracoes';
import { NotFound } from '@/pages/404';

export default function App() {
  return (
    <>
      <Routes>
        {/* Public */}
        <Route path="/" element={<Landing />} />
        <Route path="/como-funciona" element={<ComoFunciona />} />
        <Route path="/precos" element={<Precos />} />
        <Route path="/advogados" element={<Advogados />} />
        <Route path="/advogados/:lawyerId" element={<AdvogadoPerfil />} />
        <Route path="/termos-mediacao" element={<TermosMediacao />} />
        <Route path="/faq" element={<Faq />} />
        <Route path="/templates" element={<Templates />} />

        {/* Auth */}
        <Route path="/login" element={<Login />} />
        <Route path="/cadastro" element={<Cadastro />} />
        <Route path="/cadastro/advogado" element={<CadastroAdvogado />} />
        <Route path="/confirmar" element={<ConfirmarEmail />} />
        <Route path="/esqueci-senha" element={<EsqueciSenha />} />
        <Route path="/resetar-senha" element={<ResetarSenha />} />

        {/* Authenticated user area */}
        <Route element={<ProtectedRoute role="users" />}>
          <Route path="/app" element={<DashboardUser />} />
          <Route path="/app/demanda/nova" element={<DemandaNova />} />
          <Route path="/app/contratos" element={<ContratosLista />} />
          <Route path="/app/contratos/novo" element={<ContratoNovo />} />
          <Route path="/app/contratos/:contractId" element={<ContratoDetalhe />} />
          <Route path="/app/tarefas" element={<UserTarefas />} />
          <Route path="/app/tarefas/:taskId" element={<TarefaDetalhe />} />
        </Route>

        {/* Authenticated lawyer area */}
        <Route element={<ProtectedRoute role="lawyers" />}>
          <Route path="/lawyer" element={<LawyerDashboard />} />
          <Route path="/lawyer/perfil" element={<LawyerPerfil />} />
          <Route path="/lawyer/precos" element={<LawyerPrecos />} />
          <Route path="/lawyer/tarefas" element={<LawyerTarefas />} />
          <Route path="/lawyer/tarefas/:taskId" element={<TarefaDetalhe />} />
          <Route path="/lawyer/financeiro" element={<LawyerFinanceiro />} />
        </Route>

        {/* Backoffice (admins only) */}
        <Route element={<ProtectedRoute role="admins" />}>
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/usuarios" element={<AdminUsuarios />} />
          <Route path="/admin/advogados" element={<AdminAdvogados />} />
          <Route path="/admin/tarefas" element={<AdminTarefas />} />
          <Route path="/admin/tarefas/:taskId" element={<AdminTarefaDetalhe />} />
          <Route path="/admin/contratos" element={<AdminContratos />} />
          <Route path="/admin/pagamentos" element={<AdminPagamentos />} />
          <Route path="/admin/avaliacoes" element={<AdminAvaliacoes />} />
          <Route path="/admin/audit-log" element={<AdminAuditLog />} />
          <Route path="/admin/configuracoes" element={<AdminConfiguracoes />} />
        </Route>

        <Route path="*" element={<NotFound />} />
      </Routes>
      <Toaster />
    </>
  );
}
